import { motion } from "framer-motion";

export default function Section({ id, eyebrow, title, subtitle, children, className = "" }) {
  return (
    <section
      id={id}
      data-testid={`section-${id || ""}`}
      className={`relative py-24 md:py-32 bg-white dark:bg-[#0B1B40] text-[#0F172A] dark:text-white ${className}`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl"
        >
          {eyebrow && <div className="section-overline">{eyebrow}</div>}
          {title && (
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-semibold leading-tight mt-5 text-balance">
              {title}
            </h2>
          )}
          {subtitle && (
            <p className="mt-5 text-lg md:text-xl text-[#475569] dark:text-blue-100 leading-relaxed">
              {subtitle}
            </p>
          )}
        </motion.div>

        <div className="mt-16">{children}</div>
      </div>
    </section>
  );
}
